import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/ui/Header';

const NotFound: React.FC = () => {
  return (
 
      <div className="text-center flex flex-col  text-white">
        <Header/>
        <div className="mb-8">
          <img
            src="/assets/images/not-found.webp"
            alt="404 Not Found"
            className="w-36 mx-auto"
          />
        </div>
        <h1 className="text-5xl font-bold mb-4 text-primary">404</h1>
        <h2 className="text-2xl font-semibold mb-6 text-white">Trang không tồn tại</h2>
        <p className="text-gray-400 mb-8">
          Trang bạn đang tìm kiếm có thể đã bị xóa, đổi tên hoặc tạm thời không khả dụng.
        </p>
        <Link 
          to="/" 
          className="bg-red-custom text-white py-3 px-6  rounded-full inline-block hover:bg-red-700 transition"
        >
          Quay lại trang chủ
        </Link>
      </div>
   
  );
};

export default NotFound;
